/* eslint-disable no-console */

// Registered only in production builds: the dev server already handles hot
// reload/offline poorly together with a caching service worker, so we skip
// it in development to avoid stale-bundle confusion.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL}sw.js`)
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}
